module.exports = __webpack_public_path__ + "assets/img/5cd3a540922c64d5714fc395b01027a6.png";